/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { dataSyncLogFailedSyncTaskPost } from '../fn/data-sync/data-sync-log-failed-sync-task-post';
import { DataSyncLogFailedSyncTaskPost$Params } from '../fn/data-sync/data-sync-log-failed-sync-task-post';

@Injectable({ providedIn: 'root' })
export class PracticeDataSyncService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dataSyncLogFailedSyncTaskPost()` */
  static readonly DataSyncLogFailedSyncTaskPostPath = '/DataSync/LogFailedSyncTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataSyncLogFailedSyncTaskPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dataSyncLogFailedSyncTaskPost$Response(params?: DataSyncLogFailedSyncTaskPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = dataSyncLogFailedSyncTaskPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataSyncLogFailedSyncTaskPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dataSyncLogFailedSyncTaskPost(params?: DataSyncLogFailedSyncTaskPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.dataSyncLogFailedSyncTaskPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

}
